import { Link } from "react-router-dom";
import RightIcon from "../../../../assets/Icons/Setting/Profile/AdvanceCardIcon.svg";
import CardImage from "../../../../assets/Images/Setting/Profile/AdvanceCardImg.png";

const AdvanceInfoCard = ({ title, description, path }) => {
  return (
    <Link
      className="flex-row align-center p-1 radius-6  back-white g-1"
      style={{
        boxShadow: "0 0 17px -8px var(--grayColor)",
        textDecoration: "none",
      }}
      to={path}
      state={"setting"}
    >
      <div className="flex-col align-start justify-between g-05">
        <div className="flex-row align-start justify-start g-05">
          <h2
            className="poppins-medium t-17 weight-500 color-black"
            style={{ wordBreak: "break-word" }}
          >
            {title}
          </h2>
          <img
            src={RightIcon}
            alt="icon"
            style={{ width: "1.3rem", height: "1.3rem" }}
          />
        </div>
        <p className="t-10 poppins color-grayColor">{description}</p>
      </div>

      <img
        src={CardImage}
        alt=""
        style={{ objectFit: "cover", width: "6rem", height: "100%" }}
      />
    </Link>
  );
};

export default AdvanceInfoCard;
